import React from 'react';
import { Grid } from '@material-ui/core';

import Description from 'components/typography/Description';
import CreateRecipeButton from 'components/buttons/CreateRecipeButton';

const EmptyRecipes = () => {
  return (
    <Grid container direction="column">
      <Grid item>
        <Description>
          You have <b>no</b> recipes yet
        </Description>
      </Grid>

      <Grid item style={{ marginTop: 32 }}>
        <CreateRecipeButton></CreateRecipeButton>
      </Grid>
    </Grid>
  );
};

export default EmptyRecipes;
